<template>
    <div>
        <card>
            <card-header>
                Swell Connector instances
            </card-header>

            <card-body :class="{'p-0': instances.length}">
               <card-spinner
                    v-if="loading"
                    style="height: 240px;"
                />

                <table class="table" v-if="!loading && instances.length">
                    <thead>
                        <tr>
                            <th>Team name</th>
                            <th>Instance name</th>
                            <th class="text-center">Last synced</th>
                            <th class="text-center">Last heartbeat</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="instance in instances" :key="instance.id">
                            <td>{{ instance.team_name }}</td>
                            <td>
                                {{ instance.name }}
                            </td>
                            <td class="text-center">
                                {{ instance.last_synced_at ? dateFormat(instance.last_synced_at) : '---' }}
                            </td>
                            <td class="text-center">
                                {{ instance.last_heartbeat_at ? dateFormat(instance.last_heartbeat_at) : '---' }}
                            </td>
<!--                            TODO commenting this button out till we know for sure we don't need it-->
<!--                            <td class="text-right">-->
<!--                                <button class="btn btn-default btn-sm"-->
<!--                                    @click="impersonate(instance.team_owner_id)"-->
<!--                                    v-if="spark.userId !== instance.team_owner_id">-->
<!--                                    <i class="fa fa-search cursor-pointer"></i>-->
<!--                                    Impersonate-->
<!--                                </button>-->
<!--                            </td>-->
                        </tr>
                    </tbody>
                </table>

                <div class="alert alert-info" role="alert"
                    v-if="!loading && !instances.length">
                    Not results for display.
                </div>
            </card-body>
        </card>

        <pagination
            :meta="meta"
            :links="links"
            @page="fetchData"
        />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                instances: [],
                meta: {},
                links: {}
            };
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData(page = 1) {
                this.loading = true;

                this.$http
                    .get(this.$laroute.route('spark.kiosk.flare-connector-report'), {
                        params: {
                            page: page
                        }
                    })
                    .then(response => {
                        this.instances = response.data.data;
                        this.meta = response.data.meta;
                        this.links = response.data.links;

                        this.loading = false;
                    })
                    .catch(error => console.error(error));
            },

            //update to work with cognito if we bring
            // impersonate(user) {
            //     window.location = `/spark/kiosk/users/impersonate/${user}`;
            // },

            dateFormat(date) {
                return this.$options.filters.date(date);
            }
        }
    };
</script>
